import React, {
  memo,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import ReportTypesCard from "./ReportTypesCard";
import AlertContext from "../../../../context/AlertContext";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import constants from "../../../../constants";
import Table from "../../../CommonComponents/Table";
import TopicSvgIcon from "../../../../Svg/TopicSvgIcon";
import CCQuestionComponent from "./CCQuestionComponent";
import { useParams } from "react-router-dom";
// import Pagination from "../../../CommonComponents/Pagination";
import PaginationComponent from "../../../CommonComponents/PaginationComponent";
import Search from "../../../CommonComponents/Search";
import Tooltip from "../../../CommonComponents/Tooltip";
import IconButton from "../../../CommonComponents/IconButton";
import { useDebouncedValue } from "../../../../Hooks/useDebounceValue";
import ExportPdf from "../../Dashboard/ExportPdf";
import ExportToCsv from "../../Dashboard/ExportToCsv";
import Loading from "../../../Notification-Loading/Loading/Loading";
import Modal from "../../../CommonComponents/Modal";
import { useRef } from "react";
import { getDataFromStorage } from "../../../../util";

import NameCell from "../../../CommonComponents/NameCell";
import { UserReportProvider } from "../../../../context/UserReportContext";

const CodingChallengeReport = ({
  className,
  learnerId,
  fromPage = "activitypage",
}) => {
  const Alert = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const { renderDataToPDF } = ExportPdf();
  const { downloadIndividualExcel } = ExportToCsv();
  const downloadIconRef = useRef(null);
  const containerRef = useRef(null);
  const scrollDir = useRef("right");
  //States for getting data
  const [data, setData] = useState([]);
  const [dataIsLoading, setIsDataLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const pageSize = 10;
  const columns = [
    {
      key: "Topic",
      title: "Topic",
      className: "Topic",
    },
    {
      key: "Easy",
      title: "Easy",
      className: "Easy",
    },
    {
      key: "Medium",
      title: "Medium",
      className: "Medium",
    },
    {
      key: "Hard",
      title: "Hard",
      className: "Hard",
    },
    {
      key: "Total",
      title: "Total",
      className: "Total",
    },
  ];
  const [rowData, setRowData] = useState([]);
  //States for header
  const [headerData, setHeaderData] = useState([
    {
      svg: (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.7094 9.46581V10.3293C19.7083 12.3532 19.0529 14.3225 17.8411 15.9435C16.6293 17.5645 14.926 18.7503 12.9851 19.3242C11.0443 19.898 8.96994 19.8291 7.07147 19.1277C5.173 18.4263 3.55211 17.13 2.45055 15.4322C1.34899 13.7343 0.825778 11.7259 0.958943 9.70637C1.09211 7.68686 1.87452 5.7645 3.18948 4.226C4.50445 2.68749 6.28151 1.61526 8.25565 1.16924C10.2298 0.723207 12.2952 0.927271 14.1439 1.75099M19.7094 2.81556L10.324 12.2104L7.50839 9.39474"
            stroke="#12B76A"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      name: "Easy",
      count: 0,
      style: {},
    },
    {
      svg: (
        <svg
          width="19"
          height="21"
          viewBox="0 0 19 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.89845 17.242L7.44698 18.4756C7.61004 18.8429 7.87615 19.1549 8.21304 19.3739C8.54993 19.5929 8.94311 19.7094 9.34492 19.7093C9.74672 19.7094 10.1399 19.5929 10.4768 19.3739C10.8137 19.1549 11.0798 18.8429 11.2429 18.4756L11.7914 17.242C11.9866 16.8042 12.3151 16.4393 12.7299 16.1992C13.1474 15.9584 13.6303 15.8558 14.1096 15.9061L15.4517 16.049C15.8512 16.0913 16.2544 16.0167 16.6124 15.8344C16.9704 15.6521 17.2678 15.3698 17.4685 15.0218C17.6695 14.674 17.7653 14.2754 17.7442 13.8743C17.7231 13.4732 17.586 13.0868 17.3496 12.762L16.555 11.6702C16.2721 11.2785 16.1209 10.8071 16.1233 10.3239C16.1232 9.84203 16.2758 9.37254 16.5592 8.98282L17.3538 7.89098C17.5902 7.56623 17.7273 7.17984 17.7484 6.77871C17.7695 6.37759 17.6737 5.97895 17.4727 5.63118C17.2719 5.28321 16.9745 5.00094 16.6165 4.81862C16.2586 4.6363 15.8554 4.56174 15.4559 4.604L14.1138 4.74687C13.6345 4.7972 13.1515 4.69463 12.7341 4.45384C12.3184 4.21235 11.9899 3.84548 11.7956 3.4058L11.2429 2.17214C11.0798 1.80491 10.8137 1.49289 10.4768 1.27391C10.1399 1.05493 9.74672 0.938411 9.34492 0.938477C8.94311 0.938411 8.54993 1.05493 8.21304 1.27391C7.87615 1.49289 7.61004 1.80491 7.44698 2.17214L6.89845 3.4058C6.70411 3.84548 6.37556 4.21235 5.95991 4.45384C5.54246 4.69463 5.05954 4.7972 4.58025 4.74687L3.23397 4.604C2.83446 4.56174 2.43127 4.6363 2.07329 4.81862C1.7153 5.00094 1.4179 5.28321 1.21715 5.63118C1.01613 5.97895 0.920363 6.37759 0.941465 6.77871C0.962567 7.17984 1.09963 7.56623 1.33603 7.89098L2.13066 8.98282C2.41404 9.37254 2.56665 9.84203 2.56656 10.3239C2.56665 10.8058 2.41404 11.2752 2.13066 11.665L1.33603 12.7568C1.09963 13.0816 0.962567 13.4679 0.941465 13.8691C0.920363 14.2702 1.01613 14.6688 1.21715 15.0166C1.4181 15.3644 1.71554 15.6465 2.07347 15.8288C2.4314 16.0111 2.83449 16.0858 3.23397 16.0438L4.57608 15.9009C5.05537 15.8506 5.53829 15.9532 5.95574 16.1939C6.37295 16.4348 6.70301 16.8017 6.89845 17.242Z"
            stroke="#F79009"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.34324 13.1395C10.8983 13.1395 12.1589 11.8789 12.1589 10.3239C12.1589 8.76887 10.8983 7.50827 9.34324 7.50827C7.78821 7.50827 6.52761 8.76887 6.52761 10.3239C6.52761 11.8789 7.78821 13.1395 9.34324 13.1395Z"
            stroke="#F79009"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      name: "Medium",
      count: 0,
      style: {},
    },
    {
      svg: (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.078 6.56973V3.7541L16.8936 0.938477L17.8322 2.81556L19.7093 3.7541L16.8936 6.56973H14.078ZM14.078 6.56973L10.3239 10.3238M19.7093 10.3239C19.7093 15.5073 15.5073 19.7093 10.3239 19.7093C5.14047 19.7093 0.938477 15.5073 0.938477 10.3239C0.938477 5.14047 5.14047 0.938477 10.3239 0.938477M15.0166 10.3239C15.0166 12.9156 12.9156 15.0166 10.3239 15.0166C7.73218 15.0166 5.63118 12.9156 5.63118 10.3239C5.63118 7.73218 7.73218 5.63118 10.3239 5.63118"
            stroke="#F04438"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      name: "Hard",
      count: 0,
      style: {},
    },
    {
      svg: (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.50827 0.938477V14.0781M0.938477 7.50827H14.0781"
            stroke="#2E90FA"
            strokeWidth="1.87708"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      name: "Total",
      count: 0,
      style: {},
    },
  ]);
  //details of single learner
  const [ccSecName, setccSecName] = useState(null);
  const [secid, setSecid] = useState(null);

  //reportpage
  let { id } = useParams();
  const [reportColumn, setReportColumn] = useState([]);
  const [paginationPageNo, setPaginatinoPageNo] = useState(1);
  const [reportData, setReportData] = useState([]);
  // const [totalStudentsCount, setTotalStudentsCount] = useState(0);
  const [totalPagesForPagination, setTotalPagesForPagination] = useState(0);
  const debouncedSearchValue = useDebouncedValue(searchValue, 2000);
  const [reportLearnerId, setReportLearnerId] = useState(null);
  const [ccQuestionFormOpen, setCcQuestionFormOpen] = useState(false);
  //custom render
  const [showComplexityData, setShowComplexityData] = useState(false);
  // const [activeSection, setActiveSection] = useState(null);

  //Download
  const [showDownloadOptionsDropDown, setShowDownloadOptionsDropDown] =
    useState(false);
  // const [dataIsLoading, setdataIsLoading] = useState(false);

  useEffect(() => {
    const clickOutSide = (e) => {
      if (
        downloadIconRef.current &&
        !downloadIconRef.current.contains(e.target)
      ) {
        setShowDownloadOptionsDropDown(false);
      }
    };
    if (showDownloadOptionsDropDown) {
      document.addEventListener("mousedown", clickOutSide);
    }
    return () => {
      document.removeEventListener("mousedown", clickOutSide);
    };
  }, [showDownloadOptionsDropDown]);

  const fetchAllDataForDownload = async () => {
    try {
      setIsDataLoading(true);
      if (fromPage === "activitypage") {
        setccSecName(null);
        setSecid(null);
      }
      const response = await axios.get(
        `node/admin/cc/section/question?${fromPage === "activitypage"
          ? `learnerId=${learnerId}`
          : `name=${searchValue}&page=${paginationPageNo}&limit=${pageSize}&batchid=${id}&allData=true`
        }`,
        useCommonFunctionHks.getHeaderDetailsForAxios()
      );
      return response?.data?.data ?? [];
    } catch (error) {
      console.error(error);
      handleResponse("Error", error.message);
    } finally {
      setIsDataLoading(false);
    }
  };
  const handlePdfDownload = async () => {
    const allData = await fetchAllDataForDownload();

    if (allData && allData.length > 0) {
      const downloadData = prepareDownloadData(allData);
      const orientation = "landscape";
      renderDataToPDF(
        downloadData,
        orientation,
        "a4",
        `CodingChallenge_Report`
      );
    }
    setShowDownloadOptionsDropDown(false);
  };

  // Handle CSV download
  const handleCsvDownload = async () => {
    const allData = await fetchAllDataForDownload();
    if (allData && allData.length > 0) {
      const downloadData = prepareDownloadData(allData);
      downloadIndividualExcel(downloadData, `CodingChallenge_Report`);
    }
    setShowDownloadOptionsDropDown(false);
  };

  const prepareDownloadData = (data ) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [];
    }
    const result = data.map((student) => {
      const row = {
        Name: student[0].firstname,
      };

      student.forEach((data) => {
        row[data.sectionName] = `${(data.easySolved ?? 0) +
          (data.mediumSolved ?? 0) +
          (data.hardSolved ?? 0)
          }/${data.total ?? 0}`;
      });
      return row;
    });
    return result;
  };

  //function
  const handleResponse = useCallback(
    (title, msg) => {
      Alert.setShowNotify({
        show: true,
        title: title,
        msg: msg,
      });
    },
    [Alert]
  );

  const onClickSection = (col, section) => {
    setReportColumn((prevColumns) => {
      if (!prevColumns.length) return prevColumns;

      const copyColumn = [...prevColumns];
      const sectionIndex = copyColumn.findIndex((c) => c.title === col.title);

      const hasComplexityColumns =
        copyColumn[sectionIndex].hasOwnProperty("isExpanded") &&
        copyColumn[sectionIndex]["isExpanded"];

      if (hasComplexityColumns) {
        copyColumn.splice(sectionIndex - 3, 3);
        copyColumn[sectionIndex - 3] = {
          ...copyColumn[sectionIndex - 3],
          isExpanded: false,
        };
      } else {
        copyColumn.splice(
          sectionIndex,
          0,
          {
            title: "Easy",
            key: `${col.title}-Easy`,
            className: "easy-complexity-column",
          },
          {
            title: "Medium",
            key: `${col.title}-Medium`,
            className: "medium-complexity-column",
          },
          {
            title: "Hard",
            key: `${col.title}-Hard`,
            className: "hard-complexity-column",
          }
        );
        copyColumn[sectionIndex + 3] = {
          ...copyColumn[sectionIndex + 3],
          isExpanded: true,
        };
      }

      return copyColumn;
    });
  };

  const normalizeLetters = (name) => {
    if (!name) return ""; // handle null/undefined/empty
    const trimmed = name.trim();
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  };
  console.log("What is this page  ? ", fromPage);
  const fetchData = useCallback(async () => {
    try {
      setIsDataLoading(true);
      if (fromPage === "activitypage") {
        setccSecName(null);
        setSecid(null);
      }
      const response = await axios.get(
        `node/admin/cc/section/question?${fromPage === "activitypage"
          ? `learnerId=${learnerId}`
          : `name=${searchValue}&page=${paginationPageNo}&limit=${pageSize}&batchid=${id}`
        }`,
        useCommonFunctionHks.getHeaderDetailsForAxios()
      );
      if (response?.data?.resultCode === constants.RESULT_STATUS.SUCCESS) {
        setData(response?.data?.data);
        if (fromPage === "activitypage") {
          let curr = [];
          response?.data?.data?.questions.map((d) => {
            let rowData = {};
            const compList = JSON.parse(d.complexity);
            rowData["Topic"] = d.name;
            let currTotalSolved = 0;
            let currTotal = 0;
            compList
              .sort((a, b) => Number(a.complexityId) - Number(b.complexityId))
              .forEach((comp) => {
                rowData[
                  comp.complexityName === "Difficult"
                    ? "Hard"
                    : `${comp.complexityName}`
                ] = `${comp.solvedCount}/${comp.totalCount}`;
                currTotalSolved += comp.solvedCount;
                currTotal += comp.totalCount;
              });
            rowData["Total"] = `${currTotalSolved}/${currTotal}`;
            curr.push(rowData);
          });
          setRowData(curr);
          setHeaderData((prev) =>
            prev.map((p) => {
              switch (p.name) {
                case "Easy":
                  return {
                    ...p,
                    count: `${response?.data?.data?.totalSolved?.easySolved ?? 0
                      }/${response?.data?.data?.easyCount ?? 0}`,
                  };
                case "Medium":
                  return {
                    ...p,
                    count: `${response?.data?.data?.totalSolved?.mediumSolved ?? 0
                      }/${response?.data?.data?.mediumCount ?? 0}`,
                  };
                case "Hard":
                  return {
                    ...p,
                    count: `${response?.data?.data?.totalSolved?.hardSolved ?? 0
                      }/${response?.data?.data?.hardCount ?? 0}`,
                  };
                case "Total":
                  return {
                    ...p,
                    count: `${response?.data?.data?.totalSolved?.totalSolved ?? 0
                      }/${response?.data?.data?.totalCount ?? 0}`,
                  };
                default:
                  return p;
              }
            })
          );
        } else if (fromPage === "reportpage") {
          // setTotalStudentsCount(response?.data?.totalCount);
          const totalPages = Math.ceil(response?.data?.totalCount / 10);
          setTotalPagesForPagination(totalPages);
          let curr = [{ key: "Name", title: "Name", className: "Name" }];

          let res = response?.data?.data[0];
          res.forEach((test) => {
            curr.push({
              title: test?.sectionName,
              key: test?.sectionName,
              className: test?.sectionName,
              renderHeader: (col) => (
                <HoverableHeader
                  section={test}
                  title={test?.sectionName}
                  showComplexityData={showComplexityData}
                  setShowComplexityData={setShowComplexityData}
                  // setActiveSection={setActiveSection}
                  col={col}
                  onClickSection={onClickSection}
                />
              ),
            });
            return curr;
          });
          let rowCurr = [];
          response.data.data.forEach((res) => {
            let rowData = {};
            rowData["Name"] = normalizeLetters(res[0]?.firstname);
            rowData["learnerId"] = res[0]?.id;
            res.forEach((data) => {
              const sectionName = data?.sectionName;
              rowData[`${sectionName}Id`] = data?.sectionId;
              rowData[data?.sectionName] = `${(data.easySolved ?? 0) +
                (data.mediumSolved ?? 0) +
                (data.hardSolved ?? 0)
                }/${data.total ?? 0}`;
              rowData[`${sectionName}-Easy`] = `${data?.easySolved ?? 0}/${data?.easy ?? 0
                }`;
              rowData[`${sectionName}-Medium`] = `${data?.mediumSolved ?? 0}/${data?.medium ?? 0
                }`;
              rowData[`${sectionName}-Hard`] = `${data?.hardSolved ?? 0}/${data?.hard ?? 0
                }`;
            });
            rowCurr.push(rowData);
          });
          setReportData(rowCurr);
          setReportColumn(curr);
        }
      }
      console.log("response?.data?.message:", response?.data);

      if (
        response?.data?.resultCode ===
        constants.RESULT_STATUS.NO_DATA
      ) {
        setReportData([]);
      }
    } catch (error) {
      console.error(error);
      handleResponse("Error", error.message);
    } finally {
      setIsDataLoading(false);
    }
  }, [learnerId, paginationPageNo, debouncedSearchValue]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const DownloadIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 12.5V15.8333C17 16.2754 16.8244 16.6993 16.5118 17.0118C16.1993 17.3244 15.7754 17.5 15.3333 17.5H4.66667C4.22464 17.5 3.80072 17.3244 3.48816 17.0118C3.17559 16.6993 3 16.2754 3 15.8333V12.5M6.33333 8.33333L10.5 12.5M10.5 12.5L14.6667 8.33333M10.5 12.5V2.5"
        stroke="#667085"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  //all section details
  const renderCustomAllSectionData = (row, rowIndex, columns) => {
    return (
      <>
        <tr
          key={rowIndex}
          className="tableBodyRow"
          onClick={() => {
            if (getDataFromStorage("role") !== constants.Roles.tutor) {
              setccSecName(row?.Topic);
              setSecid(rowIndex + 1);
            }
          }}
        >
          <td className={`tableData Topic Topic`}>
            <TopicSvgIcon icon={rowIndex + 1} />
            {row?.Topic}
          </td>
          <td className={`tableData Easy Easy`}>{row?.Easy}</td>
          <td className={`tableData Medium Medium`}>{row?.Medium}</td>
          <td className={`tableData Hard Hard`}>{row?.Hard}</td>
          <td className={`tableData Total Total`}>{row?.Total}</td>
        </tr>
      </>
    );
  };

  const handlePageChange = (newPage) => {
    setPaginatinoPageNo(newPage);
  };

  const renderReportData = (row, rowIndex, columns) => {
    return (
      <tr key={rowIndex} className="tableBodyRow">
        {columns.map((col) => {
          // if (col.key === "Name") {
          //   return (
          //     <td key={col.key} className={`tableData Name`}>
          //       {row?.Name}
          //     </td>
          //   );
          // }

          if (col.key === "Name") {
            return (
              <UserReportProvider key={col.key}>
                <NameCell
                  row={{
                    ...row,
                    learnerid: row.learnerId,
                  }}
                  rowIndex={rowIndex}
                  pos="batch-report-page-container"
                />
              </UserReportProvider>
            );
          }

          // For complexity columns (Easy, Medium, Hard), just display the value
          if (
            col.key.includes("-Easy") ||
            col.key.includes("-Medium") ||
            col.key.includes("-Hard")
          ) {
            return (
              <td key={col.key} className={`tableData ${col.className}`}>
                {row[col.key] || "-"}
              </td>
            );
          }

          // For section columns, add click handler
          const sectionName = col.key;
          const sectionIdKey = `${sectionName}Id`;

          return (
            <td
              key={col.key}
              className={`tableData ${col.key} ${col.className}`}
              onClick={() => {
                if (getDataFromStorage("role") !== constants.Roles.tutor) {
                  setReportLearnerId(row?.learnerId);
                  setccSecName(sectionName);
                  setCcQuestionFormOpen(true);
                  setSecid(row[sectionIdKey]);
                }
              }}
            >
              {row[col.key]}
            </td>
          );
        })}
      </tr>
    );
  };

  const handleCardClick = () => {
    const container = containerRef.current;
    if (!container) return;

    const scrollAmount = container.firstChild?.offsetWidth + 20; // card + gap

    if (scrollDir.current === "right") {
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
      scrollDir.current = "left";
    } else {
      container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      scrollDir.current = "right";
    }
  };
  return (
    <div className={`cc-report-page-admin-container ${className}`}>
      {dataIsLoading && <Loading overlay/>}
      {fromPage === "activitypage" && (
        <>
          <div className="cc-report-page-admin-header">
            <div
              className={`cc-report-page-admin-header-title ${secid ? "secid" : ""
                }`}
              onClick={() => {
                setccSecName(null);
                setSecid(null);
                fetchData();
              }}
            >{`Attempted`}</div>
            {ccSecName && (
              <svg
                width="6"
                height="10"
                viewBox="0 0 6 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.800049 8.80005L4.80005 4.80005L0.800049 0.800049"
                  stroke="#344054"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
            <div className="cc-report-page-admin-header-topic">{`${ccSecName ? ccSecName : ""
              }`}</div>
          </div>
          <div
            className="ccandmocktest-report-header-main-container"
            ref={containerRef}
          >
            {headerData &&
              headerData.length &&
              headerData.map((data) => (
                <ReportTypesCard data={data} onClick={handleCardClick} />
              ))}
          </div>
        </>
      )}
      {fromPage === "reportpage" && (
        <div className="cc-report-helper-container">
          <Search
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
          />
          <div
            className="downloadDropdown"
            ref={downloadIconRef}
            style={{ position: "relative", zIndex: 1000 }}
          >
            {showDownloadOptionsDropDown && (
              <div
                className="downloadOptions"
                // onMouseLeave={() => setShowDownloadOptionsDropDown(false)}
                style={{
                  position: "absolute",
                  right: 0,
                  left: "-80px",
                  top: "100%",
                  marginTop: "4px",
                  backgroundColor: "white",
                  border: "1px solid #E4E7EC",
                  borderRadius: "8px",
                  boxShadow:
                    "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                  padding: "4px",
                  minWidth: "120px",
                  zIndex: 10, // Fixed: Set very high to appear above header menus
                }}
              >
                <div
                  className="option"
                  onClick={handlePdfDownload}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px 12px",
                    cursor: dataIsLoading ? "not-allowed" : "pointer",
                    borderRadius: "6px",
                    transition: "background-color 0.2s",
                    opacity: dataIsLoading ? 0.5 : 1,
                  }}
                  onMouseEnter={(e) =>
                    !dataIsLoading &&
                    (e.currentTarget.style.backgroundColor = "#F9FAFB")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "transparent")
                  }
                >
                  <span className="svgiconfordownload">
                    <i
                      className="fa fa-file-pdf-o"
                      style={{
                        color: "red",
                        width: "20px",
                        height: "18px",
                      }}
                    ></i>
                  </span>
                  <p
                    className="optiontext"
                    style={{ margin: 0, fontSize: "14px", fontWeight: 500 }}
                  >
                    PDF
                  </p>
                </div>
                <div
                  className="option"
                  onClick={handleCsvDownload}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px 12px",
                    cursor: dataIsLoading ? "not-allowed" : "pointer",
                    borderRadius: "6px",
                    transition: "background-color 0.2s",
                    opacity: dataIsLoading ? 0.5 : 1,
                  }}
                  onMouseEnter={(e) =>
                    !dataIsLoading &&
                    (e.currentTarget.style.backgroundColor = "#F9FAFB")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "transparent")
                  }
                >
                  <span className="svgiconfordownload">
                    <svg
                      width="20"
                      height="18"
                      viewBox="0 0 20 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.8247 1.50248H12.486C12.4596 1.50248 12.4397 1.50248 12.4133 1.50908V-0.00297165L0 1.41664V16.5437L12.4133 18.003V16.4513C12.4397 16.4513 12.4596 16.4579 12.486 16.4579H18.8247C19.135 16.4579 19.4322 16.3391 19.6567 16.1212C19.8745 15.9033 20 15.6127 20 15.3024V2.65797C20 2.34764 19.8745 2.05711 19.6567 1.83922C19.4322 1.62793 19.135 1.50248 18.8247 1.50248ZM3.52592 9.88148C3.73721 9.88148 3.9485 9.84846 4.14658 9.78244L4.25883 10.3965C4.12017 10.4625 3.81644 10.5352 3.41367 10.522C2.31099 10.4955 1.75636 9.76263 1.75636 8.81182C1.75636 7.67613 2.51568 7.02245 3.4863 6.99604C3.86926 6.98283 4.16639 7.06207 4.29845 7.12809L4.14658 7.74876C3.9485 7.66953 3.73721 7.62331 3.51931 7.62991C2.93826 7.63651 2.49587 8.01287 2.49587 8.759C2.50248 9.43909 2.87884 9.86827 3.52592 9.88148ZM5.5926 10.5748C5.20304 10.5616 4.81347 10.4493 4.62859 10.3371L4.78706 9.69C5.05117 9.82866 5.3417 9.90789 5.64543 9.92109C6.00858 9.9277 6.20007 9.77583 6.20007 9.54473C6.20007 9.32024 6.035 9.19478 5.61902 9.04292C5.05117 8.83823 4.68141 8.51469 4.68141 8.01287C4.68141 7.41862 5.16342 6.94982 5.97557 6.93001C6.37174 6.9168 6.66887 6.99604 6.88016 7.08848L6.70188 7.74876C6.47078 7.64312 6.21987 7.58369 5.96236 7.59029C5.62562 7.5969 5.46055 7.75536 5.46055 7.94024C5.46055 8.16474 5.65203 8.26378 6.10102 8.42885C6.72829 8.65995 7.02542 8.99009 7.02542 9.49851C7.01882 10.0994 6.55662 10.6012 5.5926 10.5748ZM9.44206 10.621L8.43843 10.5946L7.25652 6.95642L8.16771 6.93661L8.62331 8.48168C8.74876 8.91746 8.86761 9.34005 8.96005 9.80224H8.97986C9.0723 9.35985 9.19775 8.91746 9.32321 8.49488L9.81842 6.89699L10.7626 6.87058L9.44206 10.621ZM19.3265 15.2958C19.3265 15.4279 19.2737 15.5533 19.1812 15.6458C19.0888 15.7382 18.9567 15.791 18.8247 15.791H12.486C12.4596 15.791 12.4397 15.791 12.4133 15.7844V2.16936C12.4397 2.16276 12.4596 2.16276 12.486 2.16276H18.8247C18.9567 2.16276 19.0888 2.21558 19.1812 2.30802C19.2737 2.40046 19.3265 2.52592 19.3265 2.65797V15.2958Z"
                        fill="#0B8938"
                      />
                    </svg>
                  </span>
                  <p
                    className="optiontext"
                    style={{ margin: 0, fontSize: "14px", fontWeight: 500 }}
                  >
                    CSV
                  </p>
                </div>
              </div>
            )}
            <Tooltip placement="bottom" title="Download" isIcon={true}>
              <IconButton
                hierarchy="tertiaryGrey"
                onClick={() => setShowDownloadOptionsDropDown((prev) => !prev)}
                disabled={data?.length === 0 || dataIsLoading}
              >
                <DownloadIcon />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      )}
      {fromPage === "activitypage" ? (
        ccSecName ? (
          <CCQuestionComponent
            secid={secid}
            ccSecName={ccSecName}
            learnerId={learnerId}
            from={"activitypage"}
            setHeaderData={setHeaderData}
          />
        ) : (
          <Table
            columns={columns}
            data={rowData}
            renderRow={renderCustomAllSectionData}
            className=""
          />
        )
      ) : (
        //Report Page
        <Table
          key={reportColumn?.length ?? 0}
          columns={reportColumn}
          data={reportData}
          renderRow={renderReportData}
          className="cc-report-page-table"
        />
      )}
      {fromPage === "reportpage" && (
        <PaginationComponent
          current={paginationPageNo}
          total={totalPagesForPagination}
          className={"cc"}
          onChange={handlePageChange}
        />
      )}
      <Modal
        centered
        showCloseIcon={true}
        isOpen={ccQuestionFormOpen}
        title={`${ccSecName}`}
        onClose={() => {
          setCcQuestionFormOpen(false);
          setSecid(null);
          setccSecName(null);
        }}
        className={"ccreportpage"}
      >
        {/* {dataIsLoading && <Loading/>} */}
        <CCQuestionComponent
          secid={secid}
          ccSecName={ccSecName}
          learnerId={reportLearnerId}
          from={fromPage}
        />
      </Modal>
    </div>
  );
};

const HoverableHeader = memo(({ title, col, onClickSection }) => {
  const [isHovered, setIsHovered] = useState(false);

  const isPinned = col.isExpanded || false; // Get from column property
  const showIcon = isHovered || isPinned;

  return (
    <div
      className="ccandmocktest-report-table-hover-section"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className={`icon ${showIcon ? "visible" : ""}`}
        onClick={(e) => {
          e.stopPropagation();
          onClickSection(col, title);
        }}
      >
        {isPinned ? (
          /* pinned icon - click to collapse */
          <svg width="9" height="8" viewBox="0 0 9 8">
            <path
              d="M4.63889 6.30556L7.41667 3.52778L4.63889 0.75M0.75 6.30556L3.52778 3.52778L0.75 0.75"
              stroke="#344054"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          /* unpinned icon - click to expand */
          <svg width="9" height="8" viewBox="0 0 9 8">
            <path
              d="M3.52778 6.30556L0.75 3.52778L3.52778 0.75M7.41667 6.30556L4.63889 3.52778L7.41667 0.75"
              stroke="#344054"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      <div className="name">{title}</div>
    </div>
  );
});

export default CodingChallengeReport;
